import {
    Branch, Per, Tally, ProductPriceParameters, Product2, ProductPer
} from 'ep-bt-field-agent-proxy';
import { TallyEntryLineModel } from '../models/tally-entry-line.model';
import { EpbtFaTallyModel } from '../models/epbt-fa-tally.model';
import { OrderLineType, OrderStatus } from 'ep-bt-controls';


export class EpbtFaQuickTransferLineModel {

    constructor(product: Product2) {
        this.product = product;
        this.per = null;
        this.tallyCustom = new EpbtFaTallyModel();
        this.tallyEntryLines = [];
        this.lineType = OrderLineType.ProductLine;

        if (this.isTallyLine) {
            // Split the comma-separated TallyLengths string, remove empty/null values, and convert each to a decimal.
            const tallyLengths = this.product.tallyLengths.split(',');

            let index = 0;
            // this.quickOrderLine.TallyEntryLines = [];
            tallyLengths.forEach(tally => {
                const entryLine: TallyEntryLineModel = new TallyEntryLineModel(
                    ++index,
                    -1,
                    Number(tally),
                    product.width,
                    product.thickness,
                    0,
                    0,
                    product.inputPer.perId,
                    product.imperial ? 'ft' : 'm',
                    0,
                    null,
                    true,
                    product.imperial,
                    null
                );
                this.tallyEntryLines.push(entryLine);
            });
        }
    }

    // EpbtFaQuickTransferLineModel() {

    // }
    public product?: Product2 | undefined;
    public inputPer?: Per | undefined;
    public per?: Per | undefined;
    public tally?: Tally | undefined;
    public tallyCustom?: EpbtFaTallyModel | undefined;
    // public isTallyLine?: boolean | undefined;
    public lineNumber?: number | undefined;
    public productCode?: string | undefined;
    public productDescription?: string | undefined;
    public quantity?: number | undefined;
    public perID?: number | undefined;
    public perCode?: string | undefined;
    public inputPerID?: number | undefined;
    public inputPerCode?: string | undefined;
    public inputPerName?: string | undefined;
    public branchId?: number | undefined;
    public adding?: boolean | undefined;
    public tallyEntryLines?: TallyEntryLineModel[] | undefined;
    public totalTallyLength?: number | undefined;
    public totalTallyArea?: number | undefined;
    public totalTallyVolume?: number | undefined;
    public quantityTally?: string | undefined;
    public unitCostPrice?: number | undefined;
    public totalCost?: number | undefined;
    public lineType?: number | undefined;
    public orderLineId?: number | undefined;
    public orderId?: number | undefined;
    public lineStatus?: OrderStatus | undefined;
    public isSave?: boolean | undefined;
    // created to maintain the selected per from per dropdown
    public selectedPer?: ProductPer | undefined;

    // public IsTallyLine
    //     {
    //         get { return this.Product.ShouldTallyProduct(); }
    //     }

    public get isTallyLine(): boolean {
        return this.checkTallyProduct(this.product.tallyLengths);
    }

    public checkTallyProduct(tallyLengths: string): boolean {
        // Do not tally if there is no tally length value at all.
        // Do not tally if there is only a single tally length (i.e. no comma).
        //  return tallyLengths != null && tallyLengths != '' && tallyLengths.includes(',');
        return tallyLengths != null && tallyLengths != '';
    }

    public GetProductPriceParameters(useManualPrice: boolean = false): ProductPriceParameters {
        const productPriceParameters = new ProductPriceParameters();
        productPriceParameters.productID = this.product.productId;
        productPriceParameters.branchID = this.branchId;
        productPriceParameters.customerID = 0; // customer ID
        productPriceParameters.quantity = this.quantity;
        productPriceParameters.quantityTally = this.quantityTally;
        productPriceParameters.inputPerID = this.inputPer == null ? this.inputPerID : this.inputPer.perId; // take whichever is populated
        productPriceParameters.manualUnitSellPrice = null;
        productPriceParameters.manualDiscount1 = 0; // discount 1
        productPriceParameters.manualDiscount2 = 0; // discount 2
        productPriceParameters.perID = !this.per ? this.perID : this.per.perId; // take whichever is populated
        productPriceParameters.unitSellPriceToConvert = null; // no manual price conversion
        productPriceParameters.unitSellPriceToConvertPerID = 0;
        productPriceParameters.totalLength = !this.tallyCustom ? null : this.tallyCustom.totalTallyLength;
        productPriceParameters.totalVolume = !this.tallyCustom ? null : this.tallyCustom.totalTallyVolume;
        productPriceParameters.numberOfPieces = !this.tallyCustom ? 0 : this.tallyCustom.totalTallyPieces;
        productPriceParameters.customerAddressID = 0; // this.DeliveryAddressID   //need to check
        return productPriceParameters;
    }
}
